import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerMenuItemColor } from '../../palette';
import { ControllerFont } from '../../fonts';

const theme = createTheme();

export const MenuItemComponent: Components = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        color: String(ControllerMenuItemColor.DefaultFg),
        ...ControllerFont.Body400R,
        minHeight: 28,
        padding: theme.spacing(0.5, 2, 0.5, 1),
        '&:hover': {
          backgroundColor: String(ControllerMenuItemColor.HoverBg),
        },
        '&.Mui-focusVisible': {
          backgroundColor: String(ControllerMenuItemColor.SelectedBg),
        },
        '& .MasonMenuItem-secondary': {
          color: String(ControllerMenuItemColor.SecondaryFg),
          '&:hover': {
            backgroundColor: String(ControllerMenuItemColor.SecondaryHoverBg),
          },
          '&.Mui-focusVisible': {
            backgroundColor: String(ControllerMenuItemColor.SecondarySelectedBg),
          },
        },
      },
    },
  },
};
